'use client';
import React from 'react';
import ArtContainer from '../ArtContainer';
import { LeadForm } from './LeadForm/LeadForm';
import { getLeadGenerationOptions } from '@services/properties/getLeadGenerationOptions';
import { leadFormId } from '../ArtGetCall';
import cn from './style.module.scss';
export default function ArtContact(props: any) {
  const [countryCode, setCountryCode] = React.useState<{}[]>([]);
  const [nationalities, setNationalities] = React.useState<{}[]>([]);

  const { t } = props;

  const leadMetaRequest = React.useMemo(() => getLeadGenerationOptions(), []);

  const setLeadMetaData = async () => {
    const { countryCode, nationalities } = await leadMetaRequest.getResponse();
    setNationalities(nationalities);
    setCountryCode(countryCode);
  };

  React.useEffect(() => {
    setLeadMetaData();
    return () => leadMetaRequest.abort();
  }, []);

  return (
    <section className={cn.contactWrapper}>
      <div
        className={cn.artContact}
        id="teaserContact"
        style={{
          /* @ts-ignore */
          '--arthouse-logo': `url(${props.arthouseLogoImg.url})`,
        }}
      >
        <div className={cn.contactInner}>
          <ArtContainer>
            <div className={cn.contactBlock}>
              <div className={cn.contactContent}>
                <h2>{t['contactHeading']}</h2>
                <p>{t['contactContent']}</p>
              </div>
              <div className={cn.contactForms} id={leadFormId}>
                <LeadForm
                  countryCodes={countryCode}
                  t={t}
                  nationalities={nationalities}
                />
              </div>
            </div>
          </ArtContainer>
        </div>
      </div>
    </section>
  );
}
